// The composer's choices, remembered per browser (a convenience: storage may be missing).
import type { Cli } from "./clis";
import { isCli } from "./clis";

export interface ChatPrefs {
  cli: Cli;
  model: string;
  stream: boolean;
}

const KEY = "ocs.chat.prefs";
export const DEFAULT_PREFS: ChatPrefs = { cli: "claude", model: "", stream: true };

export function loadPrefs(): ChatPrefs {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return DEFAULT_PREFS;
    const v = JSON.parse(raw) as Partial<ChatPrefs>;
    return {
      cli: typeof v.cli === "string" && isCli(v.cli) ? v.cli : DEFAULT_PREFS.cli,
      model: typeof v.model === "string" ? v.model : DEFAULT_PREFS.model,
      stream: typeof v.stream === "boolean" ? v.stream : DEFAULT_PREFS.stream,
    };
  } catch {
    return DEFAULT_PREFS;
  }
}

export function savePrefs(prefs: ChatPrefs): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(prefs));
  } catch {
    // private window or blocked storage: the choice lasts this page only
  }
}
